/** A max height as a share of the visible screen. On phones `vh` is the height with the browser's toolbars hidden, so
 * a `90vh` modal can run under the address bar (and hide its close button); `dvh` follows the toolbars. Browsers
 * without `dvh` keep `vh`. */
export const maxScreenHeight = (pct: number) => ({
  maxHeight: `${pct}vh`,
  '@supports (height: 1dvh)': { maxHeight: `${pct}dvh` },
});

/** Keeps a modal's header (title and close button) in view while the modal's content scrolls under it. */
export const stickyModalHeader = {
  position: 'sticky',
  top: 0,
  zIndex: 2,
  backgroundColor: 'inherit',
  backgroundImage: 'inherit',
} as const;
